import { Component, h } from 'preact';
import $ from 'jquery';
import { I } from 'intl';
import { PanZoomController } from './pan-zoom-controller';

class TcrViewer extends Component
{
    constructor(props)
    {
        super(props);

		I.Download = { de: 'Herunterladen', en: 'Download'};
        I.Share = { de: 'Teilen', en: 'Share'};

        this.show = this.show.bind(this);
        this.close = this.close.bind(this);
        this.saveAttachment = this.saveAttachment.bind(this);
        this.shareAttachment = this.shareAttachment.bind(this);
        this.imageLoaded = this.imageLoaded.bind(this);
        this.onZoomChanged = this.onZoomChanged.bind(this);

        this.state = {
            zoom: 1,
            scrollX: 0,
            scrollY: 0,
            //visible: false,
            //title: 'Demo title'
        };

        this.panZoomController = new PanZoomController(this.onZoomChanged);
    }

    componentDidMount()
    {
        window.Viewer = {
            show: this.show
        };
    }

    show(options)
    {
        return new Promise((resolve) => {
            let state = {
                title: options.title,
                type: options.type,
                visible: true,
                url: options.url,
                saveUrl: options.saveUrl,
                shareUrl: options.shareUrl,
                saveFilename: options.saveFilename,
                next: resolve
            };
            this.setState(state);
        });
    }

    close()
    {
        let next = this.state.next;
        this.setState({
            zoom: 1,
            scrollX: 0,
            scrollY: 0,
            visible: false,
            next: undefined
        });
        this.panZoomController.reset();
        if (typeof next === 'function')
        {
            next();
        }
    }

    saveAttachment()
    {
        let link = document.createElement("a");
        link.setAttribute("href", this.state.saveUrl);
        link.setAttribute("download", this.state.saveFilename);
        document.body.appendChild(link);
        link.click(); // This will download the file.
        link.remove();
    }

    async shareAttachment()
    {
        if (!window.ReactNativeWebView || typeof window.ReactNativeWebView.postMessage !== 'function') return;
        
        window.ProgressBox.show('Einen Moment bitte...');
        //download file from url with jquery ajax
        let {success, data} = await new Promise((resolve) => {
            $.ajax({
                url: this.state.shareUrl,
                method: 'get',
                xhrFields: {
                    responseType: 'blob'
                },
                success: function(data) {
                    resolve({success: true, data});
                },
                error: function(err) {
                    resolve({success: false, err});
                }
            });
        });

        console.log('shareAttachment', success, data);
        if (success)
        {
            let file = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = _e => resolve(reader.result);
                reader.onerror = _e => resolve(false);
                reader.onabort = _e => resolve(false);
                reader.readAsDataURL(data);
            });
            console.log(file.substr(0, 100));
            window.ReactNativeWebView.postMessage(JSON.stringify({ action: 'share', filename: this.state.saveFilename, file }));
        }

        window.ProgressBox.hide(false);
    }

    imageLoaded(e)
    {
        console.log('image loaded', e.target.localName);
        if (e.target.localName === 'img')
        {
            e.target.parentElement.classList.add('loaded');
            //console.log(getComputedStyle(e.target));;
            //this.setState({width: e.target.width, height: e.target.clientHeight})
        }
        else if (e.target.localName === 'iframe')
        {
            e.target.classList.add('loaded');
        }
    }

    onZoomChanged(zoom, scrollX, scrollY)
    {
        this.setState({
            zoom: zoom, 
            scrollX: scrollX, 
            scrollY: scrollY
        });
    }

    render()
    {
        if (!this.state.visible) return;

        let viewer, printer;
        if (typeof this.state.type === 'string' && this.state.type.indexOf('image') === 0)
        {
            viewer = [
                <div class="image-viewer" {...this.panZoomController.events}>
                    <img ref={dom => { this.imgRef = dom; }} src={this.state.url} style={{transform: `translateX(${this.state.scrollX}px) translateY(${this.state.scrollY}px) scale(${this.state.zoom})`}} onLoad={this.imageLoaded} />
                </div>,
                <div class="spinner"></div>
            ];
        }
        else
        {
            viewer = [
                <iframe ref={(iframe) => { this.iframe = iframe;}} src={this.state.url} onLoad={this.imageLoaded}></iframe>,
                <div class="spinner"></div>
            ];
        }
        if (!window.runningInApp)
        {
            if (this.state.saveUrl)
            {
                printer = <div class="action" data-hide={this.state.edit} onClick={this.saveAttachment}>{I.Download}</div>;
            }
            else if (this.state.shareUrl)
            {
                printer = <div class="action" data-hide={this.state.edit} onClick={this.shareAttachment}>{I.Share}</div>;
            }
        }

        return (
            <div class="tcr-viewer">
                <div class="panel">
                    <div class="titlebar" data-show={this.state.scrolled}>
                        <div class="title">{this.state.title}</div>
                        <div class="actions">
                            {printer}
                            <div class="x" onClick={this.close}></div>
                        </div>
                    </div>
                    {/* <iframe src="/journals/files/BRQvNBL0zxLl32kN5hJdH8gGan0efF6s"></iframe> */}
                    {/* <iframe src="/journals/files/frNWQ6x1HdNhfWnY8pwX6MiWq6vDy6Zf"></iframe> */}
                    {viewer}
                </div>
            </div>
        );
    }
}

export { TcrViewer };
